// Module
var code = "<kintrans-form model=\"item\" on-close=\"$close(model)\">\n</kintrans-form>";
// Exports
module.exports = code;